import { loader } from '@monaco-editor/react';
import { isNodeEvnProduction } from '@prophecy/utils/env';
let isConfigured = false;
export const initializeMonacoEditorLoader = () => {
    if (isConfigured)
        return;
    loader.config({
        paths: {
            vs: isNodeEvnProduction()
                ? `${window.location.origin}${process.env.PUBLIC_URL}/monaco-editor@0.52.2/min/vs`
                : 'https://cdn.jsdelivr.net/npm/monaco-editor@0.52.2/min/vs'
        }
    });
    isConfigured = true;
};
